import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import styles from './ProgressBar.module.scss';

const ProgressBar = ({ loading, className }) => {
    const intl = useIntl();

    return (
        <div className={[styles.outer, className].join(' ')} role='alert'>
            <span className="govuk-visually-hidden">{intl.formatMessage({ id: 'loading' })}</span>
            <div data-testid='progressBar' className={[styles.inner, loading ? styles.loading : null].join(' ')} />
        </div>
    );
};

ProgressBar.propTypes = {
    loading: PropTypes.bool,
    className: PropTypes.string
};

ProgressBar.defaultProps = {
    loading: true
};

export default ProgressBar;
